<template>
    <div
        class="ResourceItem"
        :class="{'bg--white-dirty' : open}"
    >
        <article>
            <BaseButton
                class="ResourceItem__toggle"
                :class="{'is-open' : open}"
                modifier="squared"
                @click="open = !open"
            >
                <span />
            </BaseButton>

            <div
                class="ResourceItem__content"
            >
                <header>
                    <h6 class="h6">
                        {{ resource.heading }}
                    </h6>

                    <span>
                        {{ resource.category }}
                    </span>
                </header>
            </div>
            <BaseButton
                :href="resource.url"
                modifier="small"
            >
                View more
            </BaseButton>
        </article>
        <div
            v-if="open"
            class="ResourceItem__text"
            v-html="resource.description"
        />
    </div>
</template>
<script>
export default {
    name: 'ResourceItem',
    props: {
        resource: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        open: false
    })
}
</script>
<style lang="scss" scoped>
    .ResourceItem {
        position: relative;
        padding: getSpacing(medium) 1rem;
        padding-bottom: getSpacing('medium');
        border-bottom: 1px solid getColor('grey', 'medium');

        &:last-child {
           border-bottom: none;
        }

        > article {
            display: flex;
            align-items: flex-start;

            @include media-query(lap-and-up) {
                align-items: center;
            }
        }

        @include media-query(palm) {
            padding-bottom: 90px;
        }
    }

    .ResourceItem__content {

        @include media-query(palm) {
            padding-left: getSpacing(spacer);
            width: calc(100% - 42px);
        }

        @include media-query(lap) {
            width: calc(100% - 200px);
        }

        @include media-query(desk) {
            width: calc(100% - 216px);
        }

        header {

            h6 {
                @include media-query(desk) {
                    width: 450px;
                }
                @include media-query(desk-wide) {
                    width: 600px;
                }
            }

            span {
                display: block;
                color: $action-color;
                margin-top: getSpacing(small);


                @include media-query(desk) {
                    margin-top: 0;
                    padding-left: 1rem;
                }

                @include media-query(desk-wide) {

                }
            }

            @include media-query(lap-and-up) {
                padding-left: getSpacing(spacer);
            }


            @include media-query(desk) {
                display: flex;
                align-items: center;
            }
        }

        + .BaseButton {

            @include media-query(palm) {
                position: absolute;
                margin-left: 66px;
                bottom: getSpacing('medium');
            }
        }
    }

    .ResourceItem__text {
        line-height: 1.3em;
        padding-left: 75px;
        width: 60%;
        margin-top: getSpacing(spacer);

        @include media-query(portable) {
            margin-top: getSpacing(small);
            padding-left: 66px;
        }
    }

    .ResourceItem__toggle {
        cursor: pointer;

        &:not(.is-open) {
            background: transparent;
            border: 2px solid $action-color;

            span:before, span:after {
                border-color: $action-color;
            }
        }

        &.is-open {

            span {
                transition: all 0.2s cubic-bezier(0.46, -0.41, 0.3, 1.52) 0.1s;
            }

            span:before {
                -webkit-transform: translate(-50%, -50%) rotate(180deg);
                transform: translate(-50%, -50%) rotate(180deg);
            }

            span:after {
                -webkit-transform: translate(-50%, -50%) rotate(-180deg);
                transform: translate(-50%, -50%) rotate(-180deg);
            }
        }

        span {
            position: relative;
            display: block;
            width: 60%;
            height: 60%;

            &:before, &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 90%;
                -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
                border-bottom: 2px solid getColor('white');
            }

            &:before {
                -webkit-transform: translate(-50%, -50%) rotate(90deg);
                transform: translate(-50%, -50%) rotate(90deg);
                transition: all 0.2s cubic-bezier(0.46, -0.41, 0.3, 1.52) 0.1s;
            }

            &:after {
                transition: all 0.2s cubic-bezier(0.46, -0.41, 0.3, 1.52) 0.1s;
            }
        }
    }
</style>
